module.exports = __webpack_public_path__ + "img/angle_right_blue.ebd1fccb.svg";